export default __webpack_public_path__ + "static/media/INCIDENTS-all-requests.d08944b6.png";